import { Logo } from 'icons/Logo';
import { PlusLogo } from 'icons/PlusLogo';
import type { MediaItem } from 'interfaces/content/Media';
import { NextCustomImage } from 'components/Image';
import Link from 'components/Globals/Base/Link';
import * as S from './SponsorLogoStyles';
import getCommonTestId from '@/main/constants/testsIds/common';

interface SponsorLogoProps {
  partnerLogo: MediaItem;
  className?: string;
  fortuneLogo?: MediaItem;
  partnerLogoLink: string;
}

export const SponsorLogo = ({ partnerLogo, className = '', fortuneLogo, partnerLogoLink }: SponsorLogoProps) => (
  <S.Wrapper
    className={className}
    data-cy={getCommonTestId('BRANDED_ARTICLE_SPONSOR_LOGO_LABEL')}
  >
    <div>
      {fortuneLogo ? (
        <NextCustomImage
          src={fortuneLogo.mediaItemUrl}
          alt={fortuneLogo.altText}
          width='126'
          height='32'
          style={{}}
        />
      ) : (
        <Logo />
      )}
    </div>
    <div data-cy={getCommonTestId('BRANDED_ARTICLE_LABEL_PLUS')}>
      <PlusLogo />
    </div>
    <div data-cy={getCommonTestId('BRANDED_ARTICLE_LABEL_LOGO')}>
      {partnerLogo ? (
        <Link href={partnerLogoLink}>
          <NextCustomImage
            src={partnerLogo.mediaItemUrl}
            alt={partnerLogo.altText}
            width='126'
            height='32'
            style={{
              objectFit: 'contain',
              width: '100%',
            }}
          />
        </Link>
      ) : (
        <S.Placeholder> Sponsor Logo </S.Placeholder>
      )}
    </div>
  </S.Wrapper>
);
export default SponsorLogo;
